import React from 'react';
import { useSelector } from 'react-redux';
import { FiDownload } from 'react-icons/fi';
import Loader from "react-loader-spinner";


function DocumentDisplay({ t, docArr, zipLoading, getDocumentLabel, handleDownloadPaymentReceipt, handleDownloadAllDocument, type, userRole }) {
    const doc = docArr?.filter(item => item !== null && item !== undefined);
    const userData = useSelector(({ User }) => User.data);
    return (
    <div className="col-lg-12 card"> 
        <div className="card-body form-group fv-plugins-icon-container mb-0">
            <div className="d-flex justify-content-between">
                <h3 className="card-title font-weight-bolder text-dark">{type === 'vendor' ? t("jobsManagement.infoJob.vendorDocuments") : type=="corporate" ? t("jobsManagement.infoJob.corporateDocuments") : 'Custom Documents'}</h3>
                {(doc.length !== 0) && <button disabled={zipLoading} className="btn btn-primary d-flex align-items-center" onClick={() => handleDownloadAllDocument(type)}>
                    {t("jobsManagement.infoJob.downloadAll")}
                    {zipLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                </button>}
            </div>
            <div className="mt-1 d-flex flex-wrap">
                {(doc.length === 0) 
                ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> 
                : doc.map(({ fileName, thumbnailUri, documentId }) => (
                    <div key={documentId} className="document font-weight-bold my-2 me-2">
                        <div style={{width: '-webkit-fill-available', height: '-webkit-fill-available', margin: '0 auto'}}>
                            {(thumbnailUri !== null) ? <img src={thumbnailUri} alt="Thumbnail" width="100%" height="100%" />
                                : <img src={'/Assets/nopreview.png'} alt="Thumbnail" style={{width: '200px', height: '150px'}} />}
                        </div>
                        <div className="d-flex align-items-center justify-content-between position-absolute bottom-0 bg-white p-2 " style={{width: '100%'}}>
                            <p className="m-0">{getDocumentLabel(fileName, true)}</p>
                            <FiDownload onClick={() => handleDownloadPaymentReceipt(documentId)} className="c-pointer" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
    );
}

export default DocumentDisplay;